import React, { Fragment } from 'react';
import { Box, LinearProgress } from '@mui/material';
import { Outlet } from 'react-router-dom';

import { AuthCompanyContext, useAuth } from '@homesusa/auth';
import { Header } from './header/header.component';
import { Drawer } from './drawer/drawer.component';
import { useDocumentTitle } from '../hooks';

export function Layout(): JSX.Element {
  const { refreshing } = React.useContext(AuthCompanyContext);
  const { user: userProfile } = useAuth();

  useDocumentTitle();

  const loading = (
    <Box sx={{ width: '100%' }}>
      <LinearProgress />
    </Box>
  );

  if (!userProfile) {
    return <Fragment>{loading}</Fragment>;
  }

  return (
    <Fragment>
      <Header />
      {!!refreshing ? (
        loading
      ) : (
        <Drawer>
          <Outlet />
        </Drawer>
      )}
    </Fragment>
  );
}
